import request from '@/services/base/request'

export default {
  doSignUp: (data: any) => request('/registration/', 'post', data),
  resendEmail: (data: any) => request('/registration/resend-email/', 'post', data),
  verifyToken: (data: any) => request('/registration/verify-email/', 'post', data),
  getPartner: (data: any) => request(`/registration/ref_name/${data}/`, 'get', null)
} as {[key: string]: MethodDecorator}
